// extracted by mini-css-extract-plugin
module.exports = {"header":"QuestionPage_header__1PH2u","content":"QuestionPage_content__1k3Hd","div_next":"QuestionPage_div_next__2Qe_6","div_buttons":"QuestionPage_div_buttons__FdmcR"};